import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=6617d78d&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6617d78d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6617d78d')) {
      api.createRecord('6617d78d', component.options)
    } else {
      api.reload('6617d78d', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=6617d78d&scoped=true&", function () {
      api.rerender('6617d78d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bCfFEmy1nm6w/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports